import { t } from "../i18n";

type MeetingStatus =
  | "pending"
  | "uploaded"
  | "transcribing"
  | "annotating"
  | "ready"
  | "error"
  | "awaiting_context_review";

const PULSE_STATUSES: Set<string> = new Set(["transcribing", "annotating"]);

const STATUS_CONFIG: Record<
  MeetingStatus,
  { labelKey: Parameters<typeof t>[0]; chipClass: string }
> = {
  pending:                { labelKey: "status.pending",               chipClass: "chip-pending" },
  uploaded:               { labelKey: "status.uploaded",              chipClass: "chip-uploaded" },
  transcribing:           { labelKey: "status.transcribing",          chipClass: "chip-transcribing" },
  annotating:             { labelKey: "status.annotating",            chipClass: "chip-annotating" },
  ready:                  { labelKey: "status.ready",                 chipClass: "chip-ready" },
  error:                  { labelKey: "status.error",                 chipClass: "chip-error" },
  awaiting_context_review:{ labelKey: "status.awaitingContextReview", chipClass: "chip-awaiting-review" },
};

interface StatusChipProps {
  status: string;
  /** When set, the row is locked → render the Final stage chip. */
  lockedAt?: string | null;
}

export function StatusChip({ status, lockedAt }: StatusChipProps) {
  if (lockedAt) {
    return (
      <span className="status-chip chip-ready">
        <span className="status-dot" />
        {t("status.final")}
      </span>
    );
  }
  const cfg = STATUS_CONFIG[status as MeetingStatus];
  if (!cfg) {
    return <span className="status-chip chip-pending">{status}</span>;
  }
  const pulse = PULSE_STATUSES.has(status);
  return (
    <span className={`status-chip ${cfg.chipClass}`}>
      <span className={`status-dot${pulse ? " status-dot-pulse" : ""}`} />
      {t(cfg.labelKey)}
    </span>
  );
}
